<page-heading
  [title]="'agents.openaiAssistants.pageTitle' | translate"
  [description]="'agents.openaiAssistants.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row d-flex justify-content-end">
          <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
            <button
              class="btn btn-info fw-bold"
              (click)="openCreateAssistantModal()"
            >
              {{ 'agents.openaiAssistants.addButton' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (!loadingContent && health) {
<div class="alert alert-danger d-flex align-items-start gap-2" role="alert">
  <i class="mdi mdi-alert-circle-outline fs-4"></i>
  <div class="flex-grow-1">
    <strong>{{ healthLabelKey() | translate }}</strong>
    <div>{{ 'agents.openai.healthAlertDescription' | translate }}</div>
    @if (health.lastError) {
    <small class="text-muted d-block mt-1">{{ health.lastError }}</small>
    }
  </div>
  <button
    type="button"
    class="btn btn-sm btn-outline-danger fw-semibold text-nowrap"
    (click)="resetHealth()"
    [disabled]="resettingHealth"
  >
    @if (resettingHealth) {
    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
    }
    {{ 'agents.openai.reactivate' | translate }}
  </button>
</div>
}

@if (!loadingContent && needsSetupCount > 0) {
<div class="alert alert-warning d-flex align-items-start gap-2" role="alert">
  <i class="mdi mdi-alert-outline fs-4"></i>
  <div>
    <strong>{{ 'agents.openaiAssistants.needsSetupTitle' | translate: { count: needsSetupCount } }}</strong>
    <div>{{ 'agents.openaiAssistants.needsSetupDescription' | translate }}</div>
  </div>
</div>
}

@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  @if (!loadingContent && assistants.length == 0) {
  <empty-records-component
    [icon]="'ri-robot-2-line'"
    [labelButton]="'agents.openaiAssistants.addButton' | translate"
    [subMessage]="'agents.openaiAssistants.emptySubMessage' | translate"
    [message]="'agents.openaiAssistants.emptyMessage' | translate"
    (emitEvent)="openCreateAssistantModal()"
  />
  } @if(!loadingContent && assistants.length > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'agents.openaiAssistants.creationDateColumn' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'agents.openaiAssistants.assistantNameColumn' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'agents.openaiAssistants.modelColumn' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'agents.openaiAssistants.linkedChannelsColumn' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'agents.openaiAssistants.statusColumn' | translate }}</th>
          <th>
            <span class="sr-only"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (assistantObj of assistants; track $index) {
        <tr>
          <td>
            <span>
              @if (assistantObj.createdAt) {
                {{
                  assistantObj.createdAt
                    | timezoneDate
                      : "DD/MM/YYYY"
                      : getTimezoneCompanyCurrentUser()
                }}
              } @else {
                —
              }
            </span>
          </td>
          <td>
            <strong class="text-truncate">{{
              assistantObj.name ?? ('agents.openaiAssistants.noName' | translate)
            }}</strong>
          </td>
          <td>
            <span>{{ assistantObj.model || '—' }}</span>
          </td>
          <td>
            <span>
              {{ getChannelsByIdAssistant(assistantObj.id) }}
            </span>
          </td>
          <td>
            @if (needsSetup(assistantObj)) {
            <span class="badge bg-warning">{{ 'agents.openaiAssistants.statusNeedsSetup' | translate }}</span>
            } @else {
            <span class="badge bg-success">{{ 'agents.openaiAssistants.statusReady' | translate }}</span>
            }
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
                type="button"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="openEditAssistantModal(assistantObj)"
                >
                  {{ 'agents.openaiAssistants.edit' | translate }}
                </button>
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="deleteAssistant(assistantObj)"
                >
                  {{ 'agents.openaiAssistants.remove' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
